import React from "react";
import { brandAssets } from "@nw4/theme";
import styles from "./CommonFooter.module.css";

export const COMMON_FOOTER_HEIGHT = 44;

export function CommonFooter({ fixed = false, withSpacer = fixed }) {
    const footerClassName = fixed ? `${styles.footer} ${styles.fixed}` : styles.footer;

    return (
        <>
            {fixed && withSpacer ? <div className={styles.spacer} aria-hidden="true" /> : null}
            <footer className={footerClassName}>
                <div className={styles.inner}>
                    <a href="https://www.netwalk.eu" target="_blank" rel="noopener noreferrer" className={styles.brandLink}>
                        <span className={styles.label}>powered by</span>
                        <img src={brandAssets.Logo} alt="Netwalk" className={styles.logo} />
                    </a>
                </div>
            </footer>
        </>
    );
}
